import { lazy } from 'react';
import GuestGuard from "../components/GuestGuard";

const authRoutes = [
    {
        exact: true,
        guard: GuestGuard,
        path: '/login',
        component: lazy(() => import('../views/Login'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/rfd/products/:productId',
        component: lazy(() => import('../views/TataQl'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/rfd/products/payments/:Id',
        component: lazy(() => import('../views/TataQl/CheckOut'))
    }
];

export default authRoutes;
